import { PageUnstyled } from '@office-start/office-home-app-shared';
import React from 'react';
export var AiHubSamplePage = function () {
    return (React.createElement(PageUnstyled, { name: "AiHubSamplePage" },
        React.createElement("div", null, "This component has been disabled temporarily")));
};
//# sourceMappingURL=AiHubSamplePage.js.map